import React from 'react'

const InstitucionalDelegaciones = () => {
    return (
        <div className='container p-0 fondotransparente'>
            <center>
                <h1 className='p-5 botonbordeazul text-white px-5 mx-5 py-3'>Delegaciones del Interior</h1>
            </center>
            <div className="card mb-3 mx-auto " style={{ maxWidth: "70%" }}>
                <div className="row g-0">
                    <div className="col-md-4 abs-center">
                        <img src=".\img\laquiaca.jpeg" className="img-fluid rounded-start p-3 " alt="..." />
                    </div>
                    <div className="col-md-8">
                        <div className="card-body">
                            <h2 className="card-title">Delegación La Quiaca</h2>
                            <h5>Dirección: Balcarce 452</h5>
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1099.0051022476935!2d-65.59937098015578!3d-22.103171809196066!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9406a43ceda83961%3A0x3dd2a7069994bb2b!2sBalcarce%20452%2C%20Y4650APJ%20La%20Quiaca%2C%20Jujuy!5e0!3m2!1ses!2sar!4v1681794245195!5m2!1ses!2sar" width="90%" height="300vh" className='p-4' allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card mb-3 mx-auto" style={{ maxWidth: "70%" }}>
                <div className="row g-0">
                    <div className="col-md-4 abs-center">
                        <img src=".\img\libertador.jpeg" className="img-fluid rounded-start p-3" alt="..." />
                    </div>
                    <div className="col-md-8">
                        <div className="card-body">
                            <h2 className="card-title">Delegación libertador</h2>
                            <h5 >Dirección: Avenida Libertad 592</h5>
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2170.2992501988097!2d-64.79445911064039!3d-23.818822388089544!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x941ac1973456a499%3A0x860c7b731b422f44!2sAv.%20Libertad%20N%C2%B0%20592%2C%20Y4512%20Libertador%20Gral%20San%20Mart%C3%ADn%2C%20Jujuy!5e0!3m2!1ses!2sar!4v1681793860260!5m2!1ses!2sar" width="90%" height="300vh" className='p-4' allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card mb-3 mx-auto" style={{ maxWidth: "70%" }}>
                <div className="row g-0">
                    <div className="col-md-4 abs-center">
                        <img src=".\img\sanpedro.jpeg" className="img-fluid rounded-start p-3" alt="INPROJUY San Pedro" />
                    </div>
                    <div className="col-md-8">
                        <div className="card-body">
                            <h2 className="card-title">Delegación San Pedro</h2>
                            <h5 >Dirección: Sarmiento 80</h5>
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1113.3639202266202!2d-64.87067336855678!3d-24.231806958872642!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x941a58657dd8d2dd%3A0x6a7af7c39eb9a641!2sSarmiento%2080%2C%20Y4500%20EXB%2C%20Jujuy!5e0!3m2!1ses!2sar!4v1681793388279!5m2!1ses!2sar" width="90%" height="300vh" className='p-4' allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                    </div>
                </div>
            </div>
            <br />
        </div>
    )
}

export default InstitucionalDelegaciones